module.exports = __webpack_public_path__ + "resource/img/stay.7ec35b82.png";